import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { NetworkState } from '@/modules/core/network/store/network.state';
import { getters } from './network.getters';
import { mutations } from './network.mutations';
import { actions } from './network.actions';

VueXHelper.setStoreModule(Module.NETWORK, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new NetworkState(),
  getters,
  mutations,
  actions,
};
